<template>
    <div class="detail-box">
        <div class="detail-header HeaderBar Headerbg" :class='{ active: active, scrool: scrool }'>
            <div class="position-header-main" @click="changeSidebar()">
                <i v-show="!main" class="iconfont x-a-maenbtn"></i>
                <i v-show="main" class="iconfont x-a-maenbtnx"></i>
            </div>
            <div class="detail-header-logo">
                <img v-show="zhactive" @click="changeIndex()" src="@/assets/images/index-svg-black.svg" alt="">
                <img v-show="enactive" @click="changeIndex()" src="@/assets/images/index-svg-black-en.svg" alt="">
            </div>
            <div class="detail-header-En">
                <span v-show="skill">技术支持</span>
                <span class="spancolor" :class='{ spanactive: zhactive }' @click="setLanguage('zh')">中文</span>
                <span> <el-divider direction="vertical"></el-divider></span>
                <span class="spancolor" :class='{ spanactive: enactive }' @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <div class="detail-aside AsideBar" :class="{ AsideBaractive: mianOpen }">
            <div class="HeaderI"></div>
            <div class="Sider">
                <ul class="Sider-ul">
                    <li class="Sider-ul-li" v-for="(item, i) in list" :key='i' :class="{ active: item.active }"
                        @click="tochangeli(item)">
                        <span class="spanul">{{ $t(item.name) }}</span> &nbsp;<span class="spanul2"
                            v-show="i == 1"></span>
                        <ul :class='{ active: item.show === true }' :ref="`list${i}`">
                            <li v-for="(a, index) in item.list" :key="index" :class="{ active: listLiAllidx == a.id }"
                                @click.stop="doThis(a, index)">
                                <span v-show="zhactive" class="spanli">{{ a.name }}</span>
                                <span v-show="enactive" class="spanli">{{ a.name_en }}</span>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="AsideBar-bottom">
                <span class="spancolor" :class='{ spanactive: zhactive }' @click="setLanguage('zh')">中文</span>
                <span class="spancolor" :class='{ spanactive: enactive }' @click="setLanguage('en')">EN</span>
            </div>
        </div>
        <div class="Center">
            <div class="HeaderI"></div>
            <div class="Center-box">
                <div class="Center-box-left">
                    <div class="Sider">
                        <ul class="Sider-ul">
                            <li class="Sider-ul-li" v-for="(item, i) in list" :key='i' :class="{ active: item.active }"
                                @click="tochangeli(item)">
                                <span class="spanul">{{ $t(item.name) }}</span> &nbsp;<span class="spanul2"
                                    v-show="i == 1"></span>
                                <ul :class='{ active: item.show === true }' :ref="`listlg${i}`">
                                    <li v-for="(a, index) in item.list" :key="index"
                                        :class="{ active: listLiAllidx == a.id }" @click.stop="doThis(a)">
                                        <span v-show="zhactive" class="spanli">{{ a.name }}</span>
                                        <span v-show="enactive" class="spanli">{{ a.name_en }}</span>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="Center-box-right">
                    <div class="position-center">
                        <!-- 内容开始 -->
                        <div @click="meandown" v-show="Positionidx" class="position-center-main-smallmain-active"></div>
                        <div class="position-center-main" :class="{ PositionCentermainTop: scrolls }"
                            @click="changePositionIndex()">
                            <div :class="{ HeaderI: scrolls }"></div>
                            <span>{{ $t('lang.index_li4') }}</span>
                            <i v-show="!Positionidx" class="iconfont x-zankai"></i>
                            <i v-show="Positionidx" class="iconfont x-shouqi"></i>
                            <div class="position-center-main-smallmain" :class="{ Positionboxmain: Positionidx }">

                                <div>
                                    <span>{{ $t('lang.index_li4') }}</span>
                                    <i v-show="!Positionidx" class="iconfont x-zankai"></i>
                                    <i v-show="Positionidx" class="iconfont x-shouqi"></i>
                                </div>
                                <ul>
                                    <!-- 大屏状态 -->
                                    <li @click="changePositionIndex()" v-for="(item, i) in list[3].list"
                                        :class="{ active: listLiAllidx == item.id }" :key="i"
                                        @click.stop="doThis(item)">
                                        <span v-show="zhactive" class="spanli">{{ item.name }}</span>
                                        <span v-show="enactive" class="spanli">{{ item.name_en }}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="position-center-main-title" v-show="zhactive">{{ indexlizh }}</div>
                        <div class="position-center-main-title" v-show="enactive">{{ indexlien }}</div>
                        <el-collapse v-model="activeName" accordion>
                            <el-collapse-item v-for="(item, i) in boxlist" :key='i' :title="item.title" :name="i">
                                <div v-html="item.content"></div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                    <div class="common-width">
                        <div class="Bottom">
                            <div class="Bottom-list">
                                <div v-for="(item, i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)"
                                    @mouseleave="mouseLeave(i)">
                                    <a href="javascript:;">
                                        <i class="derail-center-right-mean-i" :class="'iconfont' + ` ${item}`">
                                            <div class="box-Bottom" :class="{ bottomLi: i == idxi && i == 0 }">
                                                <div class="Triangle-down"></div>
                                                <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                                <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                            </div>
                                        </i>
                                    </a>
                                </div>
                                <!-- <share :config='config'></share> -->
                            </div>
                            <div class="Bottom-divider">
                                <el-divider></el-divider>
                            </div>
                            <div class="Bottom-icp">
                                <div><a href="javascript">{{ $t('lang.Record_1') }}</a></div>
                                <div><a href="https://beian.miit.gov.cn" target="_blank">{{ $t('lang.Record_2') }}</a>
                                </div>
                                <div class="b_span">
                                    <img src="@/assets/images/logo-police.png" alt="">
                                    <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44040402000338"
                                        rel="noreferrer" target="_blank">粤公网安备44040402000338号</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="Center-box-right1"></div>
            </div>
        </div>
        <div class="BottomLeft">
            <div class="BottomLeft-box">
                <div class="BottomLeft-list">
                    <div v-for="(item, i) in icons" :key="i" @click="iconto(i)" @mouseenter="mouseEnter(i)"
                        @mouseleave="mouseLeave(i)">
                        <a href="javascript:;">
                            <i class="derail-center-right-mean-i" :class="'iconfont' + ` ${item}`">
                                <div class="box-Bottom" :class="{ bottomLi: i == idxi && i == 0 }">
                                    <div class="Triangle-down"></div>
                                    <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
                                    <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
                                </div>
                            </i>
                        </a>
                    </div>
                    <!-- <share :config='config'></share> -->
                </div>
                <div class="BottomLeft-icp">
                    <div><a href="javascript:;">{{ $t('lang.Record_1') }}</a></div>
                    <div><a href="https://beian.miit.gov.cn" target="_blank">{{ $t('lang.Record_2') }}</a></div>
                    <div class="b_span">
                        <img src="@/assets/images/logo-police.png" alt="">
                        <a href="https://beian.mps.gov.cn/#/query/webSearch?code=44040402000338" rel="noreferrer"
                            target="_blank">粤公网安备44040402000338号</a>
                    </div>
                </div>
            </div>
        </div>
        <div class="all-center" :class="{ openicon: openicon }">
            <div class="all-center-box" @click="changeiconto"></div>
            <img v-show="zhactive" src="@/assets/images/werther-zh.jpg" alt="">
            <img v-show="enactive" src="@/assets/images/werther-en.jpg" alt="">
        </div>
    </div>
</template>
<script>
import { product, faqs, faqsList } from "@/api/index";
import { mapGetters } from "vuex"
import { Localurl } from "@/utils/validate"
export default {
    name: 'position',
    computed: {
        ...mapGetters(["languageType", "positionId"])
    },
    components: {
    },
    data() {
        return {
            idxi: -1,
            activeName: 0,
            zhactive: true,
            enactive: false,
            main: false,
            mianOpen: false,
            active: false,
            skill: false,
            headerbarlistactive: true,
            detailcenter: false,
            Positionidx: false,
            scrolls: false,
            scrool: false,
            indexli: '',
            indexlizh: '',
            indexlien: '',
            dataId: 1,
            openicon: false,
            icons: ['x-wechat', 'x-jd', 'x-tm'],
            list: [
                { name: 'lang.index_li1', url: { name: '/detail', open: true }, list: [], show: false, active: false },
                { name: 'lang.index_li2', url: { name: '/list', open: false }, list: [], show: false, active: false },
                { name: 'lang.index_li3', url: { name: '/about', open: true }, list: [], show: false, active: false },
                { name: 'lang.index_li4', url: { name: '/position', open: false }, list: [], show: false, active: true },
                { name: 'lang.index_li5', url: { name: '/callus', open: true }, list: [], show: false, active: false },
            ],
            boxlistData: [],
            boxlist: [],
            mainliHeight: 40,
            config: {
                sites: ['qq', 'wechat', 'linkedin', 'facebook', 'twitter'],
            },
            listLiAllidx: '',

        }
    },
    mounted() {
        setTimeout(() => {
            this.active = true
            this.getWidth();
            this.openicon = false;
            this.$refs[`list${3}`][0].style.height = this.list[3].list.length * this.mainliHeight + 30 + 'px';
            this.$refs[`listlg${3}`][0].style.height = this.list[3].list.length * this.mainliHeight + 30 + 'px';
        }, 500)
        this.setLanguage(this.languageType)
    },

    methods: {
        meandown() {
            console.log("关闭")
            this.Positionidx = false;
        },
        changePositionIndex() {
            this.Positionidx = !this.Positionidx
        },
        changeSidebar() {
            this.main = !this.main
            this.mianOpen = !this.mianOpen
        },
        changeIndex() { this.$router.push({ path: '/index', query: { lang: this.languageType } }) },
        getWidth() {
            if (window.innerWidth < 992 && this.headerbarlistactive) {
                this.headerbarlistactive = false
                this.detailcenter = true
            }
            if (window.innerWidth >= 992 && !this.headerbarlistactive) {
                this.headerbarlistactive = true
                this.detailcenter = false
                this.main = false
                this.mianOpen = false
            }
            if (window.innerWidth >= 468 && !this.headerbarlistactive) {
                this.openicon = false
            }
        },
        tochangeli(item) {
            if (this.$route.path == item.url.name) { return; }
            if (item.url.open) { this.$router.push(item.url.name); }
            if (!item.url.open) { this.$router.push({ path: item.url.name, query: { id: item.list[0].id } }); }
        },
        // leaveli(index){
        //     this.$refs[`list${index}`][0].style.height = '0'
        //     this.$refs[`listlg${index}`][0].style.height = '0'
        // },
        // enterli(item,index){
        //     this.list.map((i,mapidx)=>{
        //         if(item.show !== i.show){
        //             i.show = false 
        //             this.$refs[`list${mapidx}`][0].style.height = '0'
        //              this.$refs[`listlg${mapidx}`][0].style.height = '0'
        //         }
        //     })
        //     item.show = !item.show;
        //     if(index == 1 || index == 3){
        //         this.$refs[`list${index}`][0].style.height =this.list[index].list.length * this.mainliHeight+30 +'px';
        //         this.$refs[`listlg${index}`][0].style.height =this.list[index].list.length * this.mainliHeight+30 +'px';
        //     }
        // },
        doThis(item) {
            if (item.id == this.listLiAllidx) { return; }
            if (item.open) { this.$router.push({ path: item.namelink, query: { id: item.id } }); }
            this.listLiAllidx = item.id;
            if (this.languageType == 'zh') {
                this.indexlizh = item.name;
            } else {
                this.indexlien = item.name_en;
            }

            this.faqsData(item.id)
        },
        setLanguage(val) {
            this.$store.dispatch("index/language", { lang: val, a: 6598988 })
            Localurl("?lang=" + this.languageType + '&id=' + this.positionId);
            this.$i18n.locale = val;
            var list = [];
            if (val == 'zh') {
                this.zhactive = true
                this.enactive = false
                document.title = '常见问题'
                for (var i = 0; i < this.boxlistData.length; i++) {
                    list.push({
                        title: this.boxlistData[i].title,
                        content: this.boxlistData[i].content,
                        id: this.boxlistData[i].id,
                        namelink: '',
                        open: true,
                    })
                }
                // this.indexlitext = this.list[3].list[0].name;
            } else {
                this.enactive = true
                this.zhactive = false
                document.title = 'COMMON PROBLEMS'
                for (var j = 0; j < this.boxlistData.length; j++) {
                    list.push({
                        title: this.boxlistData[j].title_en,
                        content: this.boxlistData[j].content_en,
                        id: this.boxlistData[j].id,
                        namelink: '',
                        open: true,
                    })
                }
                // this.indexlitext = this.list[3].list[0].name_en;
            }
            this.boxlist = list
        },
        mouseEnter(i) { this.idxi = i },
        mouseLeave() { this.idxi = -1 },
        handleScroll() {
            if (window.pageYOffset > 20) {
                this.scrolls = true
                this.scrool = true

            } else {
                this.scrolls = false
                this.scrool = false
            }
        },
        iconto(i) {
            if (i === 0) { this.openicon = true }
            if (i === 1) { window.open("https://mall.jd.com/index-12191261.html", "_black") }
            if (i === 2) { window.open("https://x-speaker.tmall.com/?spm=a217wi.openworkbeanchtmall.widgets.2.41e65e16MbeHsw", "_black") }
        },
        changeiconto() { this.openicon = false },
        // 产品分类
        fetchData() {
            product({ pageSize: 20 }).then((res) => {
                if (res.code == 200) {
                    var data = res.data.list;
                    for (var i = 0; i < data.length; i++) {
                        this.list[1].list.push({
                            name: data[i].name,
                            name_en: data[i].name_en,
                            id: data[i].id,
                            namelink: '/list',
                            open: true,
                        })
                    }
                }

            });
            faqsList().then((res) => {
                var data = res.data.list;
                var ListArray = [];
                for (var i = 0; i < data.length; i++) {
                    this.list[3].list.push({
                        name: data[i].name,
                        name_en: data[i].name_en,
                        id: data[i].id,
                        namelink: '/position',
                        open: true,
                    })
                    ListArray.push(data[i].id)
                }

                this.setLanguage(this.languageType)
                if (this.languageType == 'zh') {
                    this.indexlizh = data[0].name;
                } else {
                    this.indexlien = data[0].name_en;
                }

                var s = ListArray.includes(parseInt(this.$route.query.id));
                if (this.$route.query.id == undefined) {
                    this.faqsData(data[0].id)
                    this.listLiAllidx = data[0].id//同时添加第一条选中
                    return;
                }
                if (s) {
                    this.faqsData(this.$route.query.id);
                    this.listLiAllidx = this.$route.query.id//同时添加第一条选中
                } else {
                    var msg = this.languageType == 'zh' ? "未找到该页面。" : "The page was not found."
                    this.$router.push({ name: '404', params: { id: msg } })
                    return;
                }

            })
        },
        faqsData(id) {
            Localurl("?lang=" + this.languageType + '&id=' + id);
            this.$store.dispatch("index/positionId", { id: id })
            faqs(id).then((res) => {
                if (res.code == 200) {
                    var data = res.data.list;
                    this.boxlistData = []
                    this.boxlist = [];
                    for (var i = 0; i < data.length; i++) {
                        var a = []
                        a.push({
                            title: data[i].title,
                            title_en: data[i].title_en,
                            content: data[i].content,
                            content_en: data[i].content_en,
                            id: data[i].id,
                            namelink: '',
                            open: true,
                        })
                        this.boxlistData.push(a[0])
                    }
                    this.setLanguage(this.languageType)




                }

            });

        },
    },
    created() {
        this.fetchData();
        window.addEventListener('resize', this.getWidth);
        document.addEventListener('scroll', this.handleScroll);
        // var znda=['规格与特点','如何佩戴','故障排除','网站支持'];
        // var znEn=['specifications and features','how to wear','troubleshooting','website support'];
        // this.list[3].list=[];
        // for(var i=0;i<znda.length;i++){
        //     this.list[3].list.push({
        //         name:znda[i],
        //         name_en:znEn[i],
        //         id:i,
        //         namelink:'/list',
        //         open:false,
        //     })
        // }


    },
    beforeDestroy() {
        document.removeEventListener('scroll', this.handleScroll);
    },
}
</script>
<style>
.position-center {
    padding: 20px;
    width: 1000px;
    min-height: 500px;
    margin: 0 auto;
}

.Center-box-right1 {
    width: 430px;
}

@media (max-width: 1550px) {
    .position-center {
        padding: 20px;
        width: 100%;

    }

    .Center-box-right1 {
        display: none;
    }
}

.position-center {
    padding: 20px;
}

.position-center-main {
    display: none;
    /* line-height: 60px; */
    font-size: 24px;
    background-color: white;
}

.position-center-main.PositionCentermainTop {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.125);
    padding: 0 20px;
}

.position-center-main span {
    margin-right: 10px;
    font-weight: 700;
    font-size: 20px;
}

.position-center-main i {
    font-size: 20px;
}

.position-center-main div ul li {
    line-height: 16px;
}

.position-center-main span,
.position-center-main i,
.position-center-main div ul li {
    cursor: pointer;
}

.position-header-main i {
    display: none
}

@media (max-width: 1200px) {}

@media (max-width: 992px) {
    .position-center-main {
        display: block;
    }

    .position-header-main i {
        display: block
    }

    .detail-header-En span {
        display: none;
    }
}

.position-center-main div ul li {
    padding: 10px 0;
}

.position-center-main-smallmain-active {
    position: fixed;
    top: 0;
    left: 50%;
    z-index: 2;
    width: 100%;
    height: 100%
}

.position-center-main-smallmain {
    position: fixed;
    top: 80px;
    left: -300px;
    background-color: white;
    width: 300px;
    height: 100vh;
    font-size: 16px;
    line-height: 30px;
    padding: 20px;
    z-index: 1;
    transition: .3s ease-in-out;

}

.position-center-main-smallmain.Positionboxmain {
    left: 0;
}

.position-center-main i {
    font-size: 16px;
}

.position-center-main-smallmain div:nth-child(1) {
    padding: 5px 0;
    display: flex;
    align-items: center;
}

/* @media (max-width:992px) {
    .position-center-main-smallmain{
         top: 0px;
    }
} */
@media (max-width: 468px) {
    .position-center-main-smallmain.Positionboxmain {
        width: 50%;
    }

    .position-center-main-smallmain {
        top: 60px;
    }

    .position-center-main span {
        line-height: 20px;
    }

    .position-center-main span,
    position-center-main-title {
        font-size: 16px;
    }

}

.listSiderunderline .spanli {
    border-bottom: 1px solid #333;
    padding: 0 0 1px 0;
}

.position-center-main-title {
    line-height: 60px;
}

.el-collapse-item__header {
    font-size: 16px !important;
    font-weight: 700 !important;
    height: none;
    line-height: normal;
    min-height: 48px !important;
}

.list-sore /deep/ .el-collapse-item__content {
    color: #363636;
}

.el-icon-arrow-right {
    font-size: 22px;
}
</style>
